<template>
    <div>
        <input :class="['form-text', $v.currValue.$error ? 'form-group--error' : '']"
               ref="number"
               @keydown.enter="save"
               v-model="currValue"
        >
        <div class="form-error" v-if="!$v.currValue.currValue && $v.currValue.$error">{{ $t('errors.mustbeanumber') }}</div>

        <Button
                class="mt-1"
                @click="save"
        >
            <icon type="save"/>
            {{ $t('SAVE') }}
        </Button>
    </div>
</template>

<script>
    import Button from "../../forms/Button";
    import Icon from "../../Icon";
    import { decimal } from 'vuelidate/lib/validators'
    export default {
        name: "Number",
        components: {
            Button,
            Icon
        },
        props: {
            value: {type: String, default: ''},
            type: {type: String, required: true}
        },
        data() {
            return {
              currValue: null,
            };
        },
        validations: {
            currValue: {
                decimal,
            },
        },
        beforeMount() {
          if(this.value) {
            this.currValue = parseFloat(this.value);
          }
        },
        methods: {
            save: function() {
                if(this.currValue) {parseFloat(this.currValue);}
                this.$v.currValue.$touch();
                if(!this.$v.$anyError) {
                    this.$emit('save', this.currValue);
                }
            }
        },
    }
</script>